import {Shape} from './index.js';

export class Line extends Shape {
	constructor({ x1, y1, x2, y2, stroke = [1, 'black'] }) {
		super({ x: x1, y: y1, width: x2 - x1, height: y2 - y1, stroke });
	}

	draw(context) {
		context.save();
		context.beginPath();
		context.moveTo(this.position.x, this.position.y);
		context.lineTo(this.position.x + this.size.width, this.position.y + this.size.height);
		context.strokeStyle = this.stroke.top.color;
		context.lineWidth = this.stroke.top.size;
		context.stroke();
		this.beforeRestore(context)
		context.restore();
	}
}
